import { SNACKBAR_ADD_MESSAGE, SNACKBAR_REMOVE_MESSAGE } from "../constants.js";

export function snackbarAddMessage(message) {
  return (dispatch) => {
    const messageId = message.id || Date.now().toString();
    message.id = messageId;
    dispatch({ type: SNACKBAR_ADD_MESSAGE, message });
  };
}

export function snackbarRemoveMessage(messageId) {
  return (dispatch) => dispatch({ type: SNACKBAR_REMOVE_MESSAGE, messageId });
}



// WEBPACK FOOTER //
// ./src/actions/snackbar.js